<template>
  <div class="home">
    <main role="main" class="ml-sm-auto col-xl-10 px-4">
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h2">{{title}}</h1>
    </div>
    <div class="row">
      <div class="col mt-4 mt-xl-0 order-1 order-xl-0">
        <div class="row mb-2" v-if="search == null && status_id == null">
          <div class="col">
            <button class="btn btn-success btn-sm" @click="ResetNew">Creer</button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <MyVuetable ref="vuetable" :rowClass="onRowClass" @pdfRow="pdfRow" @detailsRow="detailsRow" @historiqueRow="historiqueRow" :url="url" :queryString="queryString" :fields="fields" :sortOrder="sortOrder"></MyVuetable>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-4 border order-lg-12 order-0" v-if="idInt || showEditor">
        <PecEditor :id="id" @onUpdate="onUpdate" @onDelete="onDelete"></PecEditor>
      </div>
    </div>
    </main>
  </div>
</template>

<script>
/* global $ */
import MyVuetable from '@/components/MyVuetable'
import PecEditor from '@/components/PecEditor'
import { getStatus } from '@/api/crm-api.js'

export default {
  components: {
    MyVuetable,
    PecEditor
  },
  props: {
    id: [String, Number],
    status_id: [String, Number],
    search: String,
    showEditor: Boolean
  },
  data () {
    return {
      title: 'Prises en charge',
      fields: [
        {
          name: 'num_dossier',
          sortField: 'num_dossier',
          title: 'N° dossier'
        },
        {
          name: 'client_fullname',
          sortField: 'client_fullname',
          title: 'Client'
        },
        {
          name: 'modele',
          sortField: 'modele',
          title: 'Machine'
        },
        {
          name: 'serial',
          sortField: 'serial',
          title: 'N° Serie'
        },
        {
          name: 'status',
          sortField: 'status',
          title: 'Statut'
        },
        {
          name: 'begin_date',
          sortField: 'begin_date',
          title: 'Entrée',
          callback : this.formatDate
        },
        {
          name: 'status_begin_date',
          sortField: 'status_begin_date',
          title: 'Deniere Modif',
          callback : this.formatDate
        }
         ,'__slot:details_and_history_and_pdf'
      ],
      sortOrder: [
        {
          field: 'num_dossier',
          direction: 'desc'
        }
      ]
    }
  },
  computed: {
    idInt() {
      if(!isNaN(parseInt(this.id))) {
        return parseInt(this.id)
      }

      return null
    },
    url() {
      return this.search != null ? 'search/'+encodeURIComponent(this.search) : 'pecs'
    },
    queryString() {
      if(this.status_id=='-999') return 'status_id=-4 and h.status_id != 27 and h.status_id != 26 and h.status_id != 32'
      return this.status_id != null ? 'status_id='+this.status_id : ''
    }
  },
  methods: {
    formatDate(value) {
      return this.$date(value,'DD/MM/YYYY HH:mm:ss')
    },
    onRowClass(dataItem) {
      return dataItem.type == 'Express' && dataItem.status != 'Machine Restituée' && dataItem.status != 'Machine Réparée' && dataItem.status != 'Bonus Réparation + Facture' ? 'table-danger' : ''
    },
    ResetNew(){
      this.$router.replace( { name:'pecManagerNew' }).catch(() => {})
    },
    detailsRow(rowData) {
      if(this.search != null) {
        this.$router.push({name:'search', params: { id: rowData.id, search: this.search}}).catch(() => {})
      } else if(this.status_id != null) {
        this.$router.replace({name:'pecManagerFilteredByStatus', params: { id: rowData.id, status_id: this.status_id}}).catch(() => {})
      } else {
        this.$router.replace({name:'pecManager', params: { id: rowData.id }}).catch(() => { })
      }
    },
    historiqueRow(rowData) {
      //Add current row into history
      if(rowData.id != this.id)
        this.detailsRow(rowData)
      
      this.$router.push({name:'PecHistory', params: { id: rowData.id }}).catch(() => {})
    },
    pdfRow(rowData) {
      window.open('https://www.macinstore.fr/crm-api/api/pdf/'+rowData.id, '_blank');
    },
    onUpdate() {
      this.$refs.vuetable.refresh()
      $(window).scrollTop(0);
    },
    onDelete() {
      if(this.search != null) {
        this.$router.push({name:'search', params: { search: this.search }}).catch(() => {})
      } else if(this.status_id != null) {
        this.$router.push({name:'pecManagerFilteredByStatus', params: { status_id: this.status_id }}).catch(() => {})
      } else {
        this.$router.push({name:'pecManager'}).catch(() => {})
      }
    }
  },
  mounted () {
    if(this.status_id == -999) {
      this.title='Non réstitués'
    }
  },
  watch: {
    status_id: {
      immediate:true,
      handler: function () {
        if(this.status_id != null) {
          this.title='Prises en charge'

          if(this.status_id == -999) {
            this.title='Non réstitués'
          } else {
            getStatus(this.status_id.startsWith('-') ? this.status_id.substring(1) : this.status_id).then((response) => {
              this.title='Prises en charge - Statut '+ (this.status_id.startsWith('-') ? 'différent de ' : '') +' : '+response.data.nom
            }).catch(() => { })
            this.title='Prises en charge - Statut: '+this.status_id
          }
        } else {
          this.title='Prises en charge'
        }
      }
    },
    search: {
      immediate:true,
      handler: function () {
        if(this.search != null) {
          this.title='Recherche de "'+this.search+'"'
        } else {
          this.title='Prises en charge'
        }
      }
    },
    id () {
      this.$refs.vuetable.refresh()
      $(window).scrollTop(0);
    }
  }
}
</script>
